export const defaultLang = "en";
export const supportedLangs = {
  en: "English",
  ar: "العربية",
};